<template>
  <view class="container">

    <text class="title">碰一碰 领福利</text>
    <view class="card_list">
      <view class="card" @click="goThePage(item)" v-for="item in peng_config" :key="item.id">
        <view class="icon-bg">

          <img class="icon" :src="item.image" mode="" />
        </view>

        <view class="right-part">
          <view class="card-title">{{ item.title }}</view>
          <view class="card-subtitle">{{ item.subTitle }}</view>
        </view>


        <div class="t-cell__right-icon"><svg fill="none" viewBox="0 0 24 24" width="1em" height="1em"
            class="t-icon t-icon-chevron-right">
            <path fill="currentColor"
              d="M8.08594 17.5L13.5859 12L8.08594 6.50003L9.50015 5.08582L16.4144 12L9.50015 18.9142L8.08594 17.5Z">
            </path>
          </svg></div>

      </view>

    </view>
  </view>

  <div>
    <!-- 创建一个简单的 dialog，不使用任何外部组件 -->

    <div v-if="dialogVisible" class="dialog-overlay">
      <div class="dialog">
        <button @click="dialogVisible = false" class="closeBtn">X</button>
        <h3>WIFI：{{ wifiItem.wifiName }}</h3>
        <h3>密码：{{ wifiItem.pass }}</h3>
        <button @click="copyPassword">复制密码</button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  ref,
  getCurrentInstance,
  onMounted,
  reactive
} from 'vue'
import { useRouter } from "vue-router";
export default {
  name: 'MyComponent',
  setup() {
    const { proxy } = getCurrentInstance();
    const shop_Id = ref('1b9686ec67fb66a10105d0836028b2ea');
    const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
    const auth = proxy.$auth;
    const peng_config = ref([]);
    const wifiItem = reactive({ wifiName: '', pass: '' });
    const dialogVisible = ref(false);

    const router = useRouter();
    const goThePage = (item) => {

      // const appUrl = 'xhsdiscover://user/5f7592640000000001004a4c';
      //const appUrl = 'snssdk1128://user/profile/103164000866';
      // const appUrl = 'imeituan:meituan://restaurantid=1251402659';
      // const appUrl = 'weixin://dl/business/?appid=wxe7fb3753d7120f25&path=pages/index2/index&query=1b9686ec67fb66a10105d0836028b2ea';

      if (item.type == 'wifi') {


        wifiItem.wifiName = item.id;
        wifiItem.pass = item.id2;
        dialogVisible.value = true;
      }
      else if (item.type == 'pyq') {

        router.push('/pengYouQuanPage')
      }
      else

        window.location = item.linkUrl;
    };




    const loadShopConfig = async () => {
      await auth.signInAnonymously();
      const db = app.database();
      const shopId = shop_Id.value;
      db.collection('my_peng_config').where({ shopId, deleted: 0 }).get().then(res => {
        console.log(res.data, 890);
        res.data.forEach(item => {
          getLinkUrl(item);

        });

        peng_config.value = res.data;
      }).catch(err => {
        console.log(err);
      })

    }

    const copyPassword = () => {
      // 使用 Clipboard API 复制密码

      var e = document.createElement("textarea");
      e.setAttribute("readonly", "readonly"),
        e.value = wifiItem.pass,
        document.body.appendChild(e),
        e.select();
      try {
        document.execCommand("copy")

        alert('密码已复制到剪贴板');
        dialogVisible.value = false;
      } catch (t) {

        alert('复制失败，请手动复制文案到朋友圈发布');
      } finally {
        document.body.removeChild(e)
      }



    };
    const getLinkUrl = (item) => {
      const shopId = shop_Id.value;
      let para = '';

      switch (item.type) {
        case 'xhs':
          item.linkUrl = `xhsdiscover://user/${item.id}`;
          break;
        case 'vip':
          para = encodeURIComponent(`shopId=${shopId}`);
          item.linkUrl = `weixin://dl/business/?appid=${item.id}&path=pages/index2/index&query=${para}`;
          break;
        case 'douyin':
          item.linkUrl = `snssdk1128://user/profile/${item.id}`;
          break;
        case 'weixin':
          para = encodeURIComponent(`type=weixin&id=${item.weixinImage}`);
          item.linkUrl = `weixin://dl/business/?appid=wxe7fb3753d7120f25&path=pages/pengjump/index&query=${para}`;
          break;
        case 'sph':
          para = encodeURIComponent(`type=sph&id=${item.id}`);
          item.linkUrl = `weixin://dl/business/?appid=wxe7fb3753d7120f25&path=pages/pengjump/index&query=${para}`;
          break;
        default:

      }

    }

    onMounted(async () => {
      console.log(router.currentRoute.value.params.id,21134);
    
    shop_Id.value = router.currentRoute.value.params.id;

      loadShopConfig();
    }); // Moved onMounted inside the return statement for better readability and to ensure it's always called

    return { goThePage, peng_config, dialogVisible, wifiItem, copyPassword }; // Including app in the return if it's intended to be used in the template
  }
}
</script>

<style scoped>
/* 基础样式变量 */

/* 容器样式 */
.container {

  width: 96vw;
  min-height: 98vh;
  box-sizing: border-box;
  padding: 0;
  margin: 0;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;


}




/* 标题样式 */
.title {

  width: 80vw;
  height: 40px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 32px;
  line-height: 39px;
  text-align: center;
  padding: 5vh 0;



}

/* 卡片样式 */
.card {
  width: 90vw;


  display: flex;
  align-items: center;

  background-color: rgb(255, 255, 255);
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  display: flex;
  font-family: "PingFang SC";
  height: 76px;
  line-height: 24px;
  overflow-x: hidden;
  overflow-y: hidden;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  position: relative;
  border-bottom: 0.5px solid gray;

}

.t-cell__right-icon {
  position: absolute;
  right: 5vw;
  top: 42%;
}

/* 图标背景 */
.icon-bg {
  width: 48px;
  height: 48px;

  border-radius: 4px;
  margin-right: 15px;
}

.icon-bg img {
  width: 48px;
  height: 48px;
}

.card .right-part {
  height: 54px;
  display: flex;
  line-height: 24px;
  flex-direction: column;
  justify-content: space-between;
}

/* 卡片标题 */
.card-title {
  font-family: 'Inter', sans-serif;

  font-size: 16px;
  font-weight: 400;
  height: 24px;
  line-height: 24px;

}

/* 卡片副标题 */
.card-subtitle {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin-top: 4px;


}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  /* 确保在最上层 */
}

.dialog {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 90vw;
  text-align: center;
  position: relative;
}

.closeBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.closeBtn:hover {
  background-color: #f5f5f5;
}

.closeBtn:focus {
  outline: none;
}
</style>
